import noImage from '@/static/icons/noImage.svg';

import { HotelImageCarousel } from './HotelImageCarousel';

interface Props {
    hotelImages?: string[];
    hotelId: string;
}

const hasNoImages = (hotelImages: string[]): boolean => !(hotelImages?.length && hotelImages[0].indexOf('test') === -1);

export const HotelImages = ({ hotelImages, hotelId }: Props) => (
    <div className="ad-preview__media u-mb16" data-testid="hotelImages">
        <div className="img-format img-format--ratio2by1 img-format--crop-vertical img-format--centered">
            {hasNoImages(hotelImages) ? (
                <img
                    src={noImage.src}
                    height={noImage.height}
                    width={noImage.width}
                    loading={'lazy'}
                    alt="bilde mangler"
                    className="img-format__img u-bg-ice noImage"
                    data-testid="resultImage"
                />
            ) : hotelImages ? (
                <div className="grid__unit u-size1of1">
                    <HotelImageCarousel hotelId={hotelId} hotelImages={hotelImages} data-testid="hotelImageCarousel" />
                </div>
            ) : (
                <div />
            )}
        </div>
    </div>
);
